// extracted by mini-css-extract-plugin
module.exports = {"container":"StorePerkResults_container__wrlKj","details":"StorePerkResults_details__4_yx_"};